import { createSlice } from '@reduxjs/toolkit';

/**
 * Initial state for the platforms module in Redux.
 */
const initialState = {
    isAddTrendingCard: false,       // Flag to show/hide add trending card UI
    isAddPlatform: false,           // Flag to show/hide add platform form
    isAddPlan: false,               // Flag to show/hide add plan form
    platformList: null,             // List of all platforms
    categoryList: null,             // List of platform categories
    isAddCategory: false,           // Flag to show/hide add category form
    platformInfo: null,             // Information of a selected platform
    planInfo: null,                 // Information of a selected plan
    trendingPlatfromList: null,     // List of trending platforms/cards
    suggestedPlatforms: null,       // Suggested platforms for recommendation system
    platformPathRoot: ''            // Current path or route within platform module
};

/**
 * Redux slice for managing all platform-related UI and data state.
 */
const platformsSlice = createSlice({
    name: 'platforms',
    initialState,
    reducers: {
        setIsAddTrendingCard: (state, action) => {
            state.isAddTrendingCard = action.payload;
        },
        setIsAddPlatform: (state, action) => {
            state.isAddPlatform = action.payload;
        },
        setIsAddPlan: (state, action) => {
            state.isAddPlan = action.payload;
        },
        setPlatformList: (state, action) => {
            state.platformList = action.payload;
        },
        setCategoryList: (state, action) => {
            state.categoryList = action.payload;
        },
        setIsAddCategory: (state, action) => {
            state.isAddCategory = action.payload;
        },
        setPlatformInfo: (state, action) => {
            state.platformInfo = action.payload;
        },
        setPlanInfo: (state, action) => {
            state.planInfo = action.payload;
        },
        setTrendingPlatformList: (state, action) => {
            state.trendingPlatfromList = action.payload;
        },
        setSuggestedPlatforms: (state, action) => {
            state.suggestedPlatforms = action.payload;
        },
        setPlatformPathRoot: (state, action) => {
            state.platformPathRoot = action.payload;
        }
    },

    /**
     * Optional: Reset state using a plain string (replace with a typed action for safety).
     */
    extraReducers: (builder) => {
        builder.addCase('RESET_STATE', () => initialState);
    }
});

// Export action creators
export const {
    setIsAddTrendingCard,
    setIsAddPlatform,
    setIsAddPlan,
    setPlatformList,
    setCategoryList,
    setIsAddCategory,
    setPlatformInfo,
    setPlanInfo,
    setTrendingPlatformList,
    setSuggestedPlatforms,
    setPlatformPathRoot
} = platformsSlice.actions;

// Export reducer to be used in the Redux store
export default platformsSlice.reducer;
